import { render, staticRenderFns } from "./vpd-toolbar.vue?vue&type=template&id=89e002bc"
import script from "./vpd-toolbar.vue?vue&type=script&lang=js"
export * from "./vpd-toolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports